import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
import {AlertService, CampaignCategoryService} from '../_services';
import {CrudSavePopupComponent} from '../_directives';
import {FormBuilder, Validators} from '@angular/forms';

@Component({
  moduleId: module.id.toString(),
  selector: 'campaign-category-form',
  templateUrl: './category-edit.component.html'
})
export class CampaignCategoryFormComponent extends CrudSavePopupComponent implements OnInit {
  constructor(protected router: Router,
              protected location: Location,
              protected route: ActivatedRoute,
              protected formBuilder: FormBuilder,
              protected categoryService: CampaignCategoryService,
              protected alertService: AlertService) {
    super(router, location, route, categoryService, alertService);
    this.objectName = 'Category';
  }

  ngOnInit() {
    this.setForm(this.formBuilder.group({
      name: [null, Validators.required]
    }));

    super.ngOnInit();
  }

}
